import CryptoJS from 'crypto-js';
// 十六位十六进制数作为密钥偏移量
const SECRET_IV = CryptoJS.enc.Utf8.parse("0123456789012347");

/**
 * 加密方法
 * @param data 需要加密的数据
 * @param SECRET_KEY 钥匙
 * @returns {string}
 */
export function aesEncrypt({ data, SECRET_KEY }) {
  SECRET_KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  return new Promise((resolve, reject) => {
    if (typeof data === "object") {
      try {
        data = JSON.stringify(data);
      } catch (error) {
        console.log("encrypt error:", error);
      }
    }
    const dataHex = CryptoJS.enc.Utf8.parse(data);
    const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
      iv: SECRET_IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    // 直接返回Base64格式，与解密对应
    resolve(encrypted.toString());
  }).catch((err) => {
    console.log(err);
    return "权限不足,请联系客服人员"; //JSON.parse
  });
}

/**
 * 解密方法
 * @param data 需要解密的数据
 * @param SECRET_KEY 钥匙
 * @returns {string}
 */
export function aesDecrypt({ data, SECRET_KEY }) {
  SECRET_KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  return new Promise((resolve, reject) => {
    //加密返回的base64Str
    const decrypt = CryptoJS.AES.decrypt(data, SECRET_KEY, {
      iv: SECRET_IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    //返回解密数据
    resolve(JSON.parse(decryptedStr)); //解析字符串为对象格式
  }).catch((err) => {
    console.log("err====前端ase=======", err);
    return { code: 400, message: "数据请求错误！" };
  });
}
